export const PERMISSIONS = Object.freeze({
  FINANCEIRO: 162,
  // INTEGRACAO: 163,
  COBRANCA: 164,
  CLIENTES: 165,
  // RELATORIOS: 166,
  SOLUCOES: 167,
  ADMIN: 168,
  MASTER: 169,
});

export const PERMISSION_OPTIONS = Object.freeze([
  {
    text: "Financeiro",
    value: PERMISSIONS.FINANCEIRO,
    description:
      "Acompanhe transações, recebimentos e antecipações, além de solicitar bobinas para seus equipamentos.",
  },
  // {
  //   text: "Integração",
  //   value: PERMISSIONS.INTEGRACAO,
  //   description:
  //     "Consulte as transações realizadas por meio das nossas integrações com plataformas de e-commerce.",
  // },
  {
    text: "Cobrança",
    value: PERMISSIONS.COBRANCA,
    description:
      "Crie e gerencie links de pagamento, boletos e cobranças recorrentes.",
  },
  {
    text: "Clientes",
    value: PERMISSIONS.CLIENTES,
    description: "Visualize e gerencie sua base de clientes em um só lugar.",
  },
  {
    // text: "Relatórios",
    // value: PERMISSIONS.RELATORIOS,
    // description: "Acesse relatórios detalhados de transações e acompanhe os resultados do seu negócio.",
  },
  {
    text: "Soluções",
    value: PERMISSIONS.SOLUCOES,
    description: "Conheça todos os produtos e soluções oferecidos pela ViaInvest.",
  },
]);

export const ADMIN_PERMISSION_VALUES = Object.freeze([
  PERMISSIONS.ADMIN,
  PERMISSIONS.MASTER,
]);

export const getPermissionLabel = (value) => {
  const option = PERMISSION_OPTIONS.find((permission) => permission.value === Number(value));
  return option ? option.text : value;
};
